export const MOBILE_VIEW = 'mobile'
export const DESKTOP_VIEW = 'desktop'

export function isMobile(view) {
  return view === MOBILE_VIEW
}
